import { defineComponent as A, openBlock as t, createElementBlock as o, mergeProps as H, unref as e, renderSlot as d, createElementVNode as n, createCommentVNode as V } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const i = { key: 0 }, p = { key: 1 }, g = { key: 2 }, M = { key: 3 }, f = { key: 4 }, h = { key: 5 }, k = {
  name: "ScalarIconNumberSquareEight"
}, _ = /* @__PURE__ */ A({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(m) {
    const r = m, { bind: Z, weight: l } = u(r);
    return (s, a) => (t(), o("svg", H({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(Z)), [
      d(s.$slots, "default"),
      e(l) === "bold" ? (t(), o("g", i, a[0] || (a[0] = [
        n("path", { d: "M208,28H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V48A20,20,0,0,0,208,28Zm-4,176H52V52H204ZM88,152a40,40,0,1,0,67.6-28.91,36,36,0,1,0-55.2,0A39.87,39.87,0,0,0,88,152Zm40,16a16,16,0,1,1,16-16A16,16,0,0,1,128,168Zm-12-68a12,12,0,1,1,12,12A12,12,0,0,1,116,100Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (t(), o("g", p, a[1] || (a[1] = [
        n("path", {
          d: "M216,48V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Zm-58.19-84.61a32,32,0,1,0-43.62,0,36,36,0,1,0,43.62,0ZM112,100a16,16,0,1,1,16,16A16,16,0,0,1,112,100Zm16,72a20,20,0,1,1,20-20A20,20,0,0,1,128,172Z" }, null, -1)
      ]))) : e(l) === "fill" ? (t(), o("g", g, a[2] || (a[2] = [
        n("path", { d: "M112,100a16,16,0,1,1,16,16A16,16,0,0,1,112,100Zm16,32a20,20,0,1,0,20,20A20,20,0,0,0,128,132Zm96-84V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM164,152a35.93,35.93,0,0,0-14.19-28.61,32,32,0,1,0-43.62,0A36,36,0,1,0,164,152Z" }, null, -1)
      ]))) : e(l) === "light" ? (t(), o("g", M, a[3] || (a[3] = [
        n("path", { d: "M208,34H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V48A14,14,0,0,0,208,34Zm2,174a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V48a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2Zm-63.43-84.46a30,30,0,1,0-37.14,0,34,34,0,1,0,37.14,0ZM110,100a18,18,0,1,1,18,18A18,18,0,0,1,110,100Zm18,74a22,22,0,1,1,22-22A22,22,0,0,1,128,174Z" }, null, -1)
      ]))) : e(l) === "regular" ? (t(), o("g", f, a[4] || (a[4] = [
        n("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Zm-58.19-84.61a32,32,0,1,0-43.62,0,36,36,0,1,0,43.62,0ZM112,100a16,16,0,1,1,16,16A16,16,0,0,1,112,100Zm16,72a20,20,0,1,1,20-20A20,20,0,0,1,128,172Z" }, null, -1)
      ]))) : e(l) === "thin" ? (t(), o("g", h, a[5] || (a[5] = [
        n("path", { d: "M208,36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V48A12,12,0,0,0,208,36Zm4,172a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V48a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4Zm-69.1-84.31a28,28,0,1,0-29.8,0,32,32,0,1,0,29.8,0ZM108,100a20,20,0,1,1,20,20A20,20,0,0,1,108,100Zm20,76a24,24,0,1,1,24-24A24,24,0,0,1,128,176Z" }, null, -1)
      ]))) : V("", !0)
    ], 16));
  }
});
export {
  _ as default
};
